/**
*
* ExplicitRemoveModal
*
*/

import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';

import { useIntl } from 'react-intl';
import FormModal from 'components/interaction/FormModal/index.jsx';
import getSchema from './form.js';
import messages from './messages.js';

function ExplicitRemoveModal(props) {
  const { confirmMessage = messages.remove, ...rest } = props;
  const intl = useIntl();
  const text = intl.formatMessage(confirmMessage);
  const schema = getSchema(text, intl);
  return <FormModal {...rest} schema={schema} submitText={confirmMessage} submitVariant="danger" />;
}

ExplicitRemoveModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  confirmMessage: PropTypes.object,
};

export default ExplicitRemoveModal;
